import { render } from "./TheCertifications.vue?vue&type=template&id=ef0ba2e4&ts=true"
import script from "./TheCertifications.vue?vue&type=script&lang=ts"
export * from "./TheCertifications.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__